export default __webpack_public_path__ + "fd00ee6857a03c14a90b20f6004062f7.svg";